import React from "react";
import { BehaviorInfoMinimal } from "../api/Blueprints";
import { FlagsList } from "../shared-components/FlagsList";
import { sortNamedListAlpha } from "../utils";
import { behaviorRelabelMapping, useFamaFlags } from "../api/FamaFlags";

type Props = {
  behaviors?: BehaviorInfoMinimal[];
  showActiveOnly?: boolean;
};

export default function BlueprintBehaviorFlags({
  behaviors,
  showActiveOnly,
}: Props) {
  const { behaviorMappingActions } = useFamaFlags();
  function buildBehaviorsNameList() {
    if (!behaviors) return [];

    const list = sortNamedListAlpha(
      Array.from(
        new Set(
          behaviors
            ?.filter((pivot) => (showActiveOnly ? pivot.is_active : true))
            .map((pivot) => pivot.name)
        )
      )
    );
    return list;
  }

  if (!behaviors) return <></>;
  const sortedBehaviors = buildBehaviorsNameList();
  const relabeledBehaviors = behaviorRelabelMapping(
    sortedBehaviors,
    behaviorMappingActions
  );
  return (
    <div className="p-2 mt-2 text-sm">
      <div className="rounded-md p-2 font-bold">Fama behavior flag:</div>
      {sortedBehaviors.length > 0 ? (
        <FlagsList list={relabeledBehaviors} />
      ) : (
        <div className="py-2 pl-2">No Assigned Behaviors</div>
      )}
    </div>
  );
}
